import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/new_package_group/container/${container_id}`
    );
  },
  createPackageGroup({
    container_id,
    agro_exporter_process_id,
    pg_code,
    comment,
    thermo_code,
    grouped_at,
    row_position,
    col_position,
    packages = []
  }) {
    return RequesterV1.post(
      `/agro_exporter/production/uniq_final_packing_list/new_package_group/container/${container_id}/create`,
      {
        package_group: {
          container_id,
          agro_exporter_process_id,
          pg_code,
          comment,
          thermo_code,
          grouped_at,
          row_position,
          col_position
        },
        packages: packages
      }
    );
  },
  fetchProducersOrganizations(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_package_group/fetch_producers_organizations/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropCategories(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/show_container/list_exporter_process_crop_categories/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropVarieties(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/show_container/list_exporter_process_crop_varieties/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessCropSizes(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/new_package_group/list_exporter_process_crop_sizes/" +
        agro_exporter_process_id
    );
  },
  fetchExportProcessBrands(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/new_package_group/list_exporter_process_brands/${agro_exporter_process_id}/${container_id}`
    );
  },
  fetchExportProcessCropPackages(agro_exporter_process_id) {
    return RequesterV1.get(
      "agro_exporter/production/uniq_final_packing_list/show_container/list_exporter_process_crop_packages/" +
        agro_exporter_process_id
    );
  }
};
